import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText'

gsap.utils.toArray(".opacity").forEach((elem) => {
  const split = new SplitText(elem, { type: "words" });
  gsap.set(split.words, { y: 24, opacity: 0 });

  gsap.to(split.words, {
    stagger: 0.07,
    scrollTrigger: {
      trigger: elem,
      start: "top 80%",
      toggleActions: "play none none none",
    },
    ease: "power3.out",
    opacity: 1,
    y: 0,
    duration: 1,
  });
});
